// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Premium Digital Photography Studio — matches Our Memories landing / login */

.sd-dash {
  --sd-bg: #ffffff;
  --sd-bg-soft: #eff6ff;
  --sd-surface: #ffffff;
  --sd-ink: #0f172a;
  --sd-ink-soft: #64748b;
  --sd-ink-faint: #94a3b8;
  --sd-line: rgba(15, 23, 42, 0.1);
  --sd-line-strong: rgba(15, 23, 42, 0.14);
  --sd-accent: #2563eb;
  --sd-focus: #2563eb;
  --sd-shadow: 0 16px 40px rgba(15, 23, 42, 0.06);
  --sd-shadow-soft: 0 4px 16px rgba(15, 23, 42, 0.04);
  --sd-r: 18px;
  --sd-r-sm: 14px;
  --sd-r-xs: 10px;
  --sd-dur: 180ms;
  --sd-margin: 1rem;
  --sd-max: 1440px;
  --sd-font-display: "Cormorant Garamond", Georgia, "Times New Roman", serif;
  --sd-font-body: "Outfit", "Segoe UI", sans-serif;

  min-height: 100%;
  background: var(--sd-bg);
  color: var(--sd-ink);
  font-family: var(--sd-font-body);
  font-style: normal;
  -webkit-font-smoothing: antialiased;
}

@media (min-width: 640px) {
  .sd-dash { --sd-margin: 1.5rem; }
}
@media (min-width: 1024px) {
  .sd-dash { --sd-margin: 2rem; }
}
@media (min-width: 1440px) {
  .sd-dash { --sd-margin: 2.5rem; }
}

html.dark .sd-dash {
  --sd-bg: #151412;
  --sd-bg-soft: #1c1a18;
  --sd-surface: #1c1a18;
  --sd-ink: #ffffff;
  --sd-ink-soft: #a8a399;
  --sd-ink-faint: #78746c;
  --sd-line: rgba(255, 255, 255, 0.1);
  --sd-line-strong: rgba(255, 255, 255, 0.14);
  --sd-accent: #e2e8f0;
  --sd-focus: #e2e8f0;
  --sd-shadow: 0 16px 40px rgba(0, 0, 0, 0.4);
  --sd-shadow-soft: 0 4px 16px rgba(0, 0, 0, 0.28);
}

@keyframes sd-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

@media (prefers-reduced-motion: reduce) {
  .sd-dash *,
  .sd-dash *::before,
  .sd-dash *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

.sd-dash h1,
.sd-dash h2,
.sd-dash h3,
.sd-dash p,
.sd-dash span,
.sd-dash a,
.sd-dash button {
  font-style: normal;
}

.sd-dash-main {
  width: min(100%, var(--sd-max));
  margin: 0 auto;
  padding: 20px var(--sd-margin) 72px;
}

@media (min-width: 768px) {
  .sd-dash-main { padding: 28px var(--sd-margin) 88px; }
}

.sd-dash-gallery-photo {
  position: absolute;
  inset: 0;
}

.sd-dash-gallery-photo img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 18%;
  display: block;
}

.sd-dash-icon-sm {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* —— Header —— */
.sd-dash-header {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 28px;
}

@media (min-width: 980px) {
  .sd-dash-header {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    gap: 28px;
    margin-bottom: 32px;
  }
}

.sd-dash-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 10px;
  padding: 5px 10px;
  border-radius: 999px;
  border: 1px solid var(--sd-line);
  background: var(--sd-surface);
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--sd-ink-soft);
}

.sd-dash-greeting {
  margin: 0;
  font-family: var(--sd-font-display);
  font-size: clamp(1.85rem, 3vw, 2.55rem);
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: var(--sd-ink);
}

.sd-dash-studio {
  margin: 6px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--sd-ink-soft);
}

.sd-dash-lede {
  margin: 8px 0 0;
  max-width: 52ch;
  color: var(--sd-ink-soft);
  font-size: 0.95rem;
  line-height: 1.55;
}

.sd-dash-header__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

@media (max-width: 1100px) {
  .sd-dash-search {
    flex: 1 1 100%;
    max-width: none;
  }
}

@media (max-width: 640px) {
  .sd-dash-header__actions {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 8px;
  }

  .sd-dash-search {
    grid-column: 1 / -1;
    flex: none;
    max-width: none;
  }

  .sd-dash-btn--primary,
  .sd-dash-btn--ghost {
    width: 100%;
  }
}

.sd-dash-search {
  position: relative;
  flex: 1 1 200px;
  min-width: 160px;
  max-width: 280px;
}

.sd-dash-search__icon {
  position: absolute;
  left: 13px;
  top: 50%;
  width: 15px;
  height: 15px;
  transform: translateY(-50%);
  color: var(--sd-ink-faint);
  pointer-events: none;
}

.sd-dash-search input {
  width: 100%;
  height: 44px;
  padding: 0 14px 0 38px;
  border: 1px solid var(--sd-line-strong);
  border-radius: 999px;
  background: var(--sd-surface);
  color: var(--sd-ink);
  font-size: 14px;
  outline: none;
}

.sd-dash-search input:focus {
  border-color: var(--sd-focus);
  box-shadow: 0 0 0 3px rgba(31, 58, 52, 0.14);
}

.sd-dash-search input::placeholder {
  color: var(--sd-ink-faint);
}

.sd-dash-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  color: inherit;
  background: transparent;
  transition: background var(--sd-dur) ease, color var(--sd-dur) ease, border-color var(--sd-dur) ease;
}

.sd-dash-btn:focus-visible,
.sd-dash-chip:focus-visible,
.sd-dash-photo:focus-visible,
.sd-dash-album:focus-visible,
.sd-dash-shortcut:focus-visible,
.sd-dash-person:focus-visible,
.sd-dash-activity__row:focus-visible {
  outline: 2px solid var(--sd-focus);
  outline-offset: 2px;
}

.sd-dash-btn--primary {
  background: var(--sd-ink);
  color: var(--sd-surface);
}

.sd-dash-btn--primary:hover {
  background: var(--sd-accent);
}

html.dark .sd-dash-btn--primary {
  background: var(--sd-ink);
  color: var(--sd-bg);
}

html.dark .sd-dash-btn--primary:hover {
  background: #ffffff;
  color: #151412;
}

.sd-dash-btn--ghost {
  background: var(--sd-surface);
  border-color: var(--sd-line-strong);
  color: var(--sd-ink);
}

.sd-dash-btn--icon {
  width: 44px;
  padding: 0;
  background: var(--sd-surface);
  border-color: var(--sd-line-strong);
  color: var(--sd-ink);
}

.sd-dash-btn--tiny {
  min-height: 36px;
  padding: 0 12px;
  font-size: 12px;
  background: var(--sd-bg-soft);
  color: var(--sd-ink);
  border: 1px solid var(--sd-line-strong);
  white-space: nowrap;
}

.sd-dash-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--sd-ink);
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}

.sd-dash-link:hover { text-decoration: underline; }

/* —— Error —— */
.sd-dash-error {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding: 14px 16px;
  border: 1px solid var(--sd-line);
  border-radius: var(--sd-r-sm);
  background: var(--sd-surface);
}

.sd-dash-error__title { margin: 0; font-weight: 650; }
.sd-dash-error__desc { margin: 2px 0 0; color: var(--sd-ink-soft); font-size: 13px; }

/* —— Featured collection (split) —— */
.sd-dash-feature {
  display: grid;
  gap: 0;
  margin-bottom: 28px;
  border-radius: calc(var(--sd-r) + 4px);
  overflow: hidden;
  background: var(--sd-surface);
  border: 1px solid var(--sd-line);
  box-shadow: var(--sd-shadow-soft);
}

@media (min-width: 900px) {
  .sd-dash-feature {
    grid-template-columns: minmax(0, 1.55fr) minmax(300px, 0.95fr);
    min-height: 420px;
    align-items: stretch;
  }
}

.sd-dash-feature__media {
  position: relative;
  width: 100%;
  min-height: 260px;
  aspect-ratio: 4 / 3;
  background: var(--sd-ink);
  overflow: hidden;
}

@media (min-width: 900px) {
  .sd-dash-feature__media {
    aspect-ratio: auto;
    min-height: 420px;
    height: 100%;
    align-self: stretch;
  }
}

.sd-dash-feature__media > img,
.sd-dash-feature__media > .sd-dash-gallery-photo,
.sd-dash-feature__media > .sd-dash-cover-fallback,
.sd-dash-feature__media .sd-dash-hero__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  object-fit: cover;
  object-position: center;
  display: block;
}

.sd-dash-feature__media .sd-dash-gallery-photo {
  position: absolute;
  inset: 0;
}

.sd-dash-feature__media .sd-dash-gallery-photo img,
.sd-dash-feature__media .sd-dash-gallery-photo .sd-dash-hero__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.sd-dash-feature__panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  padding: 22px 20px 24px;
}

@media (min-width: 900px) {
  .sd-dash-feature__panel {
    padding: 36px 32px;
  }
}

.sd-dash-feature__badge {
  display: inline-flex;
  align-self: flex-start;
  padding: 5px 10px;
  border-radius: 999px;
  background: var(--sd-bg-soft);
  border: 1px solid var(--sd-line);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--sd-ink-soft);
}

.sd-dash-feature__title {
  margin: 0;
  font-family: var(--sd-font-display);
  font-size: clamp(1.55rem, 2.6vw, 2.1rem);
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.12;
  color: var(--sd-ink);
}

.sd-dash-feature__meta {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--sd-ink-soft);
}

.sd-dash-feature__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 4px;
}

.sd-dash-feature__stat strong {
  display: block;
  font-family: var(--sd-font-display);
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--sd-ink);
}

.sd-dash-feature__stat span {
  font-size: 11px;
  color: var(--sd-ink-faint);
}

.sd-dash-feature__cta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.sd-dash-feature__empty {
  grid-column: 1 / -1;
  display: grid;
  place-items: center;
  text-align: center;
  gap: 8px;
  min-height: 200px;
  padding: 36px 24px;
}

.sd-dash-feature__empty h2 {
  margin: 0;
  font-family: var(--sd-font-display);
  font-size: 1.55rem;
  font-weight: 600;
}

.sd-dash-feature__empty p {
  margin: 0;
  max-width: 38ch;
  color: var(--sd-ink-soft);
  font-size: 14px;
}

.sd-dash-cover-fallback {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(145deg, #ddd6cb, #f0ebe3);
  color: #7a7368;
}

html.dark .sd-dash-cover-fallback {
  background: linear-gradient(145deg, #23262a, #151719);
  color: #8d8780;
}

.sd-dash-cover-fallback__icon {
  width: 26px;
  height: 26px;
  opacity: 0.7;
}

.sd-dash-hero__img,
.sd-dash-photo__img,
.sd-dash-album__img,
.sd-dash-activity__thumb img,
.sd-dash-filmstrip__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* —— Studio pulse —— */
.sd-dash-pulse {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  margin-bottom: 36px;
  border: 1px solid var(--sd-line);
  border-radius: var(--sd-r);
  background: var(--sd-surface);
  overflow: hidden;
}

@media (min-width: 900px) {
  .sd-dash-pulse {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.sd-dash-pulse__item {
  padding: 18px 20px;
  border-right: 1px solid var(--sd-line);
  border-bottom: 1px solid var(--sd-line);
}

@media (min-width: 900px) {
  .sd-dash-pulse__item {
    border-bottom: none;
  }
  .sd-dash-pulse__item:nth-child(4n) {
    border-right: none;
  }
}

@media (max-width: 899px) {
  .sd-dash-pulse__item:nth-child(2n) {
    border-right: none;
  }
  .sd-dash-pulse__item:nth-last-child(-n + 2) {
    border-bottom: none;
  }
}

.sd-dash-pulse__value {
  margin: 0;
  font-family: var(--sd-font-display);
  font-size: 1.85rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1;
  color: var(--sd-ink);
}

.sd-dash-pulse__label {
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--sd-ink);
}

.sd-dash-pulse__hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--sd-ink-faint);
}

/* —— Sections —— */
.sd-dash-section {
  margin-bottom: 40px;
}

.sd-dash-section__head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.sd-dash-section__title {
  margin: 0;
  font-family: var(--sd-font-display);
  font-size: clamp(1.35rem, 1.8vw, 1.65rem);
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--sd-ink);
}

.sd-dash-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.sd-dash-chip {
  min-height: 36px;
  padding: 0 13px;
  border-radius: 999px;
  border: 1px solid var(--sd-line-strong);
  background: var(--sd-surface);
  color: var(--sd-ink-soft);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.sd-dash-chip.is-active {
  background: var(--sd-ink);
  border-color: var(--sd-ink);
  color: var(--sd-surface);
}

html.dark .sd-dash-chip.is-active {
  background: var(--sd-ink);
  border-color: var(--sd-ink);
  color: var(--sd-bg);
}

/* —— Recently added mosaic (compact, evenly framed) —— */
.sd-dash-mosaic {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

@media (min-width: 720px) {
  .sd-dash-mosaic {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
  }
}

@media (min-width: 1100px) {
  .sd-dash-mosaic {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 10px;
  }
}

.sd-dash-photo {
  display: block;
  text-decoration: none;
  color: inherit;
  border-radius: var(--sd-r-xs);
  overflow: hidden;
  background: var(--sd-bg-soft);
  isolation: isolate;
  position: relative;
}

.sd-dash-photo__media {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  min-height: 0;
  overflow: hidden;
  background: var(--sd-bg-soft);
}

.sd-dash-photo__media img,
.sd-dash-photo__media .sd-dash-gallery-photo,
.sd-dash-photo__media .sd-dash-gallery-photo img,
.sd-dash-photo__media .sd-dash-cover-fallback {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  max-width: none;
  object-fit: cover;
  object-position: center 20%;
  display: block;
}

.sd-dash-photo__media img,
.sd-dash-photo__media .sd-dash-gallery-photo {
  transition: transform var(--sd-dur) ease;
}

.sd-dash-photo:hover .sd-dash-photo__media img,
.sd-dash-photo:hover .sd-dash-photo__media .sd-dash-gallery-photo,
.sd-dash-photo:focus-visible .sd-dash-photo__media img,
.sd-dash-photo:focus-visible .sd-dash-photo__media .sd-dash-gallery-photo {
  transform: scale(1.02);
}

@media (prefers-reduced-motion: reduce) {
  .sd-dash-photo:hover .sd-dash-photo__media img,
  .sd-dash-photo:hover .sd-dash-photo__media .sd-dash-gallery-photo,
  .sd-dash-photo:focus-visible .sd-dash-photo__media img,
  .sd-dash-photo:focus-visible .sd-dash-photo__media .sd-dash-gallery-photo {
    transform: none;
  }
}

.sd-dash-photo--a,
.sd-dash-photo--b,
.sd-dash-photo--c,
.sd-dash-photo--d,
.sd-dash-photo--e,
.sd-dash-photo--f {
  grid-column: auto;
  grid-row: auto;
}

.sd-dash-photo__overlay {
  position: absolute;
  inset: auto 0 0 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 1px;
  padding: 20px 8px 8px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.72));
  color: #fff;
  opacity: 0;
  transition: opacity var(--sd-dur) ease;
}

.sd-dash-photo:hover .sd-dash-photo__overlay,
.sd-dash-photo:focus-visible .sd-dash-photo__overlay {
  opacity: 1;
}

@media (hover: none) {
  .sd-dash-photo__overlay { opacity: 1; }
}

.sd-dash-photo__title {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sd-dash-photo__time {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.74);
}

.sd-dash-photo__badge {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1;
  padding: 4px 9px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* —— Split —— */
.sd-dash-split {
  display: grid;
  gap: 28px;
}

@media (min-width: 1120px) {
  .sd-dash-split {
    grid-template-columns: minmax(0, 1.7fr) minmax(300px, 0.85fr);
    align-items: start;
  }
}

/* —— Album stories —— */
.sd-dash-album-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 640px) {
  .sd-dash-album-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.sd-dash-album {
  display: block;
  text-decoration: none;
  color: inherit;
  border-radius: var(--sd-r);
  overflow: hidden;
  background: transparent;
}

.sd-dash-album__cover {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: var(--sd-r);
  background: var(--sd-ink);
}

.sd-dash-album__share {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1;
  padding: 4px 9px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.sd-dash-album__body {
  padding: 12px 2px 0;
}

.sd-dash-album__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 560;
  letter-spacing: -0.02em;
  color: var(--sd-ink);
}

.sd-dash-album__sub {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--sd-ink-faint);
}

.sd-dash-album--lead {
  grid-column: 1 / -1;
}

@media (min-width: 640px) {
  .sd-dash-album--lead .sd-dash-album__cover {
    aspect-ratio: 21 / 9;
  }
  .sd-dash-album--lead .sd-dash-album__title {
    font-size: 1.25rem;
  }
}

/* —— Rail —— */
.sd-dash-rail {
  display: grid;
  gap: 14px;
}

.sd-dash-panel {
  padding: 16px;
  border-radius: var(--sd-r);
  background: var(--sd-surface);
  border: 1px solid var(--sd-line);
}

.sd-dash-panel .sd-dash-section__head { margin-bottom: 12px; }
.sd-dash-panel .sd-dash-section__title { font-size: 1rem; }

.sd-dash-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  padding: 3px;
  border-radius: 999px;
  background: var(--sd-bg);
}

.sd-dash-tab {
  flex: 1 1;
  min-height: 34px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: var(--sd-ink-soft);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.sd-dash-tab.is-active {
  background: var(--sd-surface);
  color: var(--sd-ink);
  box-shadow: var(--sd-shadow-soft);
}

.sd-dash-attention {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.sd-dash-attention__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  border-radius: var(--sd-r-xs);
  background: var(--sd-bg);
}

.sd-dash-attention__thumb {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  background: var(--sd-bg-soft);
}

.sd-dash-attention__body { flex: 1 1; min-width: 0; }
.sd-dash-attention__title { margin: 0; font-size: 13px; font-weight: 650; }
.sd-dash-attention__detail { margin: 2px 0 0; font-size: 12px; color: var(--sd-ink-soft); }

.sd-dash-activity {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 4px;
}

.sd-dash-activity__row {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 8px;
  border-radius: var(--sd-r-xs);
  text-decoration: none;
  color: inherit;
}

.sd-dash-activity__row:hover { background: var(--sd-bg); }

.sd-dash-activity__thumb {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  background: var(--sd-bg);
}

.sd-dash-activity__body p {
  margin: 0;
  font-size: 13px;
  font-weight: 550;
  line-height: 1.35;
}

.sd-dash-activity__body span {
  font-size: 11px;
  color: var(--sd-ink-faint);
}

/* —— People —— */
.sd-dash-clear-filters {
  margin-top: 12px;
}

.sd-dash-people-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.sd-dash-people-head__hint {
  margin: 0;
  font-size: 12px;
  color: var(--sd-ink-faint);
}

.sd-dash-people {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
}

.sd-dash-person {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 64px;
  text-decoration: none;
  color: inherit;
}

.sd-dash-person__avatar {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid var(--sd-line-strong);
  background: var(--sd-bg-soft);
  display: grid;
  place-items: center;
  font-size: 13px;
  font-weight: 700;
  color: var(--sd-ink);
}

.sd-dash-person__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sd-dash-person__new {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 1px 5px;
  border-radius: 999px;
  background: var(--sd-ink);
  color: var(--sd-surface);
  font-size: 8px;
  font-style: normal;
  font-weight: 700;
}

html.dark .sd-dash-person__new {
  background: var(--sd-ink);
  color: var(--sd-bg);
}

.sd-dash-person__name {
  max-width: 64px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sd-dash-person__count {
  font-size: 10px;
  color: var(--sd-ink-faint);
}

.sd-dash-people-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 64px;
  text-decoration: none;
  color: var(--sd-ink);
  font-size: 14px;
  font-weight: 700;
}

.sd-dash-people-more span {
  font-size: 10px;
  font-weight: 600;
}

.sd-dash-people-empty {
  display: grid;
  gap: 8px;
  color: var(--sd-ink-soft);
  font-size: 13px;
}

.sd-dash-people-empty svg {
  width: 20px;
  height: 20px;
  color: var(--sd-ink-faint);
}

.sd-dash-people-skel {
  display: flex;
  gap: 10px;
}

.sd-dash-skel--avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}

/* —— Shortcuts —— */
.sd-dash-shortcuts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 12px;
}

.sd-dash-shortcut {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--sd-bg);
  color: var(--sd-ink);
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
}

.sd-dash-shortcut svg {
  width: 15px;
  height: 15px;
  color: var(--sd-ink);
}

.sd-dash-shortcut:hover { background: var(--sd-bg-soft); }

/* —— Empty —— */
.sd-dash-empty {
  display: grid;
  gap: 8px;
  justify-items: start;
  padding: 32px 20px;
  border-radius: var(--sd-r-sm);
  border: 1px dashed var(--sd-line-strong);
  background: var(--sd-surface);
}

.sd-dash-empty__icon {
  width: 28px;
  height: 28px;
  color: var(--sd-ink-faint);
  margin-bottom: 4px;
}

.sd-dash-empty__title {
  margin: 0;
  font-family: var(--sd-font-display);
  font-size: 1.15rem;
  font-weight: 600;
}

.sd-dash-empty__desc {
  margin: 0;
  max-width: 42ch;
  color: var(--sd-ink-soft);
  font-size: 13px;
  line-height: 1.5;
}

/* —— Skeletons —— */
.sd-dash--loading {
  width: min(100%, var(--sd-max));
  margin: 0 auto;
  padding: 28px var(--sd-margin) 72px;
}

.sd-dash-skel {
  border-radius: var(--sd-r-sm);
  background: linear-gradient(90deg, rgba(20, 18, 15, 0.05), rgba(20, 18, 15, 0.09), rgba(20, 18, 15, 0.05));
  background-size: 200% 100%;
  animation: sd-shimmer 1.2s ease-in-out infinite;
}

html.dark .sd-dash-skel {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.04));
  background-size: 200% 100%;
}

.sd-dash-skel--header { height: 88px; margin-bottom: 24px; }
.sd-dash-skel--hero { height: 320px; margin-bottom: 24px; border-radius: var(--sd-r); }
.sd-dash-skel--metric { height: 88px; }
.sd-dash-skel--photo { aspect-ratio: 1; }

.sd-dash-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}

@media (min-width: 900px) {
  .sd-dash-metrics { grid-template-columns: repeat(4, minmax(0, 1fr)); }
}

.sd-dash-photo-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

@media (min-width: 720px) {
  .sd-dash-photo-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }
}

/* legacy aliases kept for safety */
.sd-dash-btn--on-dark {
  background: var(--sd-ink);
  color: var(--sd-surface);
}
.sd-dash-btn--on-dark-ghost {
  background: var(--sd-surface);
  border-color: var(--sd-line-strong);
  color: var(--sd-ink);
}
html.dark .sd-dash-btn--on-dark {
  background: var(--sd-ink);
  color: var(--sd-bg);
}

/* Soften portal chrome so dashboard matches landing / login paper */
main:has(.sd-dash) {
  padding: 0 !important;
  background: #ffffff;
}

html.dark main:has(.sd-dash) {
  background: #151412;
}

.portal-page-surface:has(.sd-dash) {
  --pp-bg: #ffffff;
  --pp-surface: #ffffff;
  --pp-surface-muted: #f1f5f9;
  --pp-text: #0f172a;
  --pp-text-muted: #64748b;
  --pp-text-faint: #94a3b8;
  --pp-border: rgba(15, 23, 42, 0.1);
  background: transparent;
  color: #0f172a;
}

html.dark .portal-page-surface:has(.sd-dash) {
  --pp-bg: #151412;
  --pp-surface: #1c1a18;
  --pp-surface-muted: #1c1a18;
  --pp-text: #ffffff;
  --pp-text-muted: #a8a399;
  --pp-text-faint: #78746c;
  --pp-border: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/StudioDashboard.premium.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,+CAA+C;EAC/C,mDAAmD;EACnD,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0EAA0E;EAC1E,gDAAgD;;EAEhD,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,WAAW,mBAAmB,EAAE;AAClC;AACA;EACE,WAAW,iBAAiB,EAAE;AAChC;AACA;EACE,WAAW,mBAAmB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,gBAAgB,mCAAmC,EAAE;AACvD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mCAAmC;IACnC,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;EACvC,oBAAoB;EACpB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,oGAAoG;AACtG;;AAEA;;;;;;;EAOE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sBAAsB,0BAA0B,EAAE;;AAElD,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,wBAAwB,SAAS,EAAE,gBAAgB,EAAE;AACrD,uBAAuB,eAAe,EAAE,yBAAyB,EAAE,eAAe,EAAE;;AAEpF,sCAAsC;AACtC;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE;IACE,8DAA8D;IAC9D,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,gDAAgD;EAChD,MAAM;EACN,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,uCAAuC;EACvC,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;EACX;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE;;;;IAIE,eAAe;EACjB;AACF;;AAEA;;;;;;EAME,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,QAAQ;EACR,qBAAqB;EACrB,6DAA6D;EAC7D,WAAW;EACX,UAAU;EACV,sCAAsC;AACxC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,0BAA0B,UAAU,EAAE;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,6DAA6D;IAC7D,kBAAkB;EACpB;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,wCAAwC,mBAAmB,EAAE;AAC7D,yCAAyC,eAAe,EAAE;;AAE1D;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA,2BAA2B,SAAO,EAAE,YAAY,EAAE;AAClD,4BAA4B,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC1E,6BAA6B,eAAe,EAAE,eAAe,EAAE,yBAAyB,EAAE;;AAE1F;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+BAA+B,wBAAwB,EAAE;;AAEzD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA,0BAA0B,6BAA6B,EAAE;;AAEzD,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,0GAA0G;EAC1G,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,mHAAmH;EACnH,0BAA0B;AAC5B;;AAEA,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;AAC3D,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,0BAA0B,EAAE;AACtF,wBAAwB,YAAY,EAAE;AACtC,uBAAuB,eAAe,EAAE;;AAExC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,gDAAgD,EAAE;AACvE;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,sBAAsB,gDAAgD,EAAE;AAC1E;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,qCAAqC;EACrC,cAAc;AAChB","sourcesContent":["/* Premium Digital Photography Studio — matches Our Memories landing / login */\n\n.sd-dash {\n  --sd-bg: #ffffff;\n  --sd-bg-soft: #eff6ff;\n  --sd-surface: #ffffff;\n  --sd-ink: #0f172a;\n  --sd-ink-soft: #64748b;\n  --sd-ink-faint: #94a3b8;\n  --sd-line: rgba(15, 23, 42, 0.1);\n  --sd-line-strong: rgba(15, 23, 42, 0.14);\n  --sd-accent: #2563eb;\n  --sd-focus: #2563eb;\n  --sd-shadow: 0 16px 40px rgba(15, 23, 42, 0.06);\n  --sd-shadow-soft: 0 4px 16px rgba(15, 23, 42, 0.04);\n  --sd-r: 18px;\n  --sd-r-sm: 14px;\n  --sd-r-xs: 10px;\n  --sd-dur: 180ms;\n  --sd-margin: 1rem;\n  --sd-max: 1440px;\n  --sd-font-display: \"Cormorant Garamond\", Georgia, \"Times New Roman\", serif;\n  --sd-font-body: \"Outfit\", \"Segoe UI\", sans-serif;\n\n  min-height: 100%;\n  background: var(--sd-bg);\n  color: var(--sd-ink);\n  font-family: var(--sd-font-body);\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n}\n\n@media (min-width: 640px) {\n  .sd-dash { --sd-margin: 1.5rem; }\n}\n@media (min-width: 1024px) {\n  .sd-dash { --sd-margin: 2rem; }\n}\n@media (min-width: 1440px) {\n  .sd-dash { --sd-margin: 2.5rem; }\n}\n\nhtml.dark .sd-dash {\n  --sd-bg: #151412;\n  --sd-bg-soft: #1c1a18;\n  --sd-surface: #1c1a18;\n  --sd-ink: #ffffff;\n  --sd-ink-soft: #a8a399;\n  --sd-ink-faint: #78746c;\n  --sd-line: rgba(255, 255, 255, 0.1);\n  --sd-line-strong: rgba(255, 255, 255, 0.14);\n  --sd-accent: #e2e8f0;\n  --sd-focus: #e2e8f0;\n  --sd-shadow: 0 16px 40px rgba(0, 0, 0, 0.4);\n  --sd-shadow-soft: 0 4px 16px rgba(0, 0, 0, 0.28);\n}\n\n@keyframes sd-shimmer {\n  0% { background-position: 100% 0; }\n  100% { background-position: -100% 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sd-dash *,\n  .sd-dash *::before,\n  .sd-dash *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n.sd-dash h1,\n.sd-dash h2,\n.sd-dash h3,\n.sd-dash p,\n.sd-dash span,\n.sd-dash a,\n.sd-dash button {\n  font-style: normal;\n}\n\n.sd-dash-main {\n  width: min(100%, var(--sd-max));\n  margin: 0 auto;\n  padding: 20px var(--sd-margin) 72px;\n}\n\n@media (min-width: 768px) {\n  .sd-dash-main { padding: 28px var(--sd-margin) 88px; }\n}\n\n.sd-dash-gallery-photo {\n  position: absolute;\n  inset: 0;\n}\n\n.sd-dash-gallery-photo img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 18%;\n  display: block;\n}\n\n.sd-dash-icon-sm {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* —— Header —— */\n.sd-dash-header {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  margin-bottom: 28px;\n}\n\n@media (min-width: 980px) {\n  .sd-dash-header {\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 28px;\n    margin-bottom: 32px;\n  }\n}\n\n.sd-dash-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 10px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--sd-line);\n  background: var(--sd-surface);\n  font-size: 10px;\n  font-weight: 650;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--sd-ink-soft);\n}\n\n.sd-dash-greeting {\n  margin: 0;\n  font-family: var(--sd-font-display);\n  font-size: clamp(1.85rem, 3vw, 2.55rem);\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n  color: var(--sd-ink);\n}\n\n.sd-dash-studio {\n  margin: 6px 0 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--sd-ink-soft);\n}\n\n.sd-dash-lede {\n  margin: 8px 0 0;\n  max-width: 52ch;\n  color: var(--sd-ink-soft);\n  font-size: 0.95rem;\n  line-height: 1.55;\n}\n\n.sd-dash-header__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n@media (max-width: 1100px) {\n  .sd-dash-search {\n    flex: 1 1 100%;\n    max-width: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .sd-dash-header__actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr auto;\n    gap: 8px;\n  }\n\n  .sd-dash-search {\n    grid-column: 1 / -1;\n    flex: none;\n    max-width: none;\n  }\n\n  .sd-dash-btn--primary,\n  .sd-dash-btn--ghost {\n    width: 100%;\n  }\n}\n\n.sd-dash-search {\n  position: relative;\n  flex: 1 1 200px;\n  min-width: 160px;\n  max-width: 280px;\n}\n\n.sd-dash-search__icon {\n  position: absolute;\n  left: 13px;\n  top: 50%;\n  width: 15px;\n  height: 15px;\n  transform: translateY(-50%);\n  color: var(--sd-ink-faint);\n  pointer-events: none;\n}\n\n.sd-dash-search input {\n  width: 100%;\n  height: 44px;\n  padding: 0 14px 0 38px;\n  border: 1px solid var(--sd-line-strong);\n  border-radius: 999px;\n  background: var(--sd-surface);\n  color: var(--sd-ink);\n  font-size: 14px;\n  outline: none;\n}\n\n.sd-dash-search input:focus {\n  border-color: var(--sd-focus);\n  box-shadow: 0 0 0 3px rgba(31, 58, 52, 0.14);\n}\n\n.sd-dash-search input::placeholder {\n  color: var(--sd-ink-faint);\n}\n\n.sd-dash-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 16px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  color: inherit;\n  background: transparent;\n  transition: background var(--sd-dur) ease, color var(--sd-dur) ease, border-color var(--sd-dur) ease;\n}\n\n.sd-dash-btn:focus-visible,\n.sd-dash-chip:focus-visible,\n.sd-dash-photo:focus-visible,\n.sd-dash-album:focus-visible,\n.sd-dash-shortcut:focus-visible,\n.sd-dash-person:focus-visible,\n.sd-dash-activity__row:focus-visible {\n  outline: 2px solid var(--sd-focus);\n  outline-offset: 2px;\n}\n\n.sd-dash-btn--primary {\n  background: var(--sd-ink);\n  color: var(--sd-surface);\n}\n\n.sd-dash-btn--primary:hover {\n  background: var(--sd-accent);\n}\n\nhtml.dark .sd-dash-btn--primary {\n  background: var(--sd-ink);\n  color: var(--sd-bg);\n}\n\nhtml.dark .sd-dash-btn--primary:hover {\n  background: #ffffff;\n  color: #151412;\n}\n\n.sd-dash-btn--ghost {\n  background: var(--sd-surface);\n  border-color: var(--sd-line-strong);\n  color: var(--sd-ink);\n}\n\n.sd-dash-btn--icon {\n  width: 44px;\n  padding: 0;\n  background: var(--sd-surface);\n  border-color: var(--sd-line-strong);\n  color: var(--sd-ink);\n}\n\n.sd-dash-btn--tiny {\n  min-height: 36px;\n  padding: 0 12px;\n  font-size: 12px;\n  background: var(--sd-bg-soft);\n  color: var(--sd-ink);\n  border: 1px solid var(--sd-line-strong);\n  white-space: nowrap;\n}\n\n.sd-dash-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--sd-ink);\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.sd-dash-link:hover { text-decoration: underline; }\n\n/* —— Error —— */\n.sd-dash-error {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding: 14px 16px;\n  border: 1px solid var(--sd-line);\n  border-radius: var(--sd-r-sm);\n  background: var(--sd-surface);\n}\n\n.sd-dash-error__title { margin: 0; font-weight: 650; }\n.sd-dash-error__desc { margin: 2px 0 0; color: var(--sd-ink-soft); font-size: 13px; }\n\n/* —— Featured collection (split) —— */\n.sd-dash-feature {\n  display: grid;\n  gap: 0;\n  margin-bottom: 28px;\n  border-radius: calc(var(--sd-r) + 4px);\n  overflow: hidden;\n  background: var(--sd-surface);\n  border: 1px solid var(--sd-line);\n  box-shadow: var(--sd-shadow-soft);\n}\n\n@media (min-width: 900px) {\n  .sd-dash-feature {\n    grid-template-columns: minmax(0, 1.55fr) minmax(300px, 0.95fr);\n    min-height: 420px;\n    align-items: stretch;\n  }\n}\n\n.sd-dash-feature__media {\n  position: relative;\n  width: 100%;\n  min-height: 260px;\n  aspect-ratio: 4 / 3;\n  background: var(--sd-ink);\n  overflow: hidden;\n}\n\n@media (min-width: 900px) {\n  .sd-dash-feature__media {\n    aspect-ratio: auto;\n    min-height: 420px;\n    height: 100%;\n    align-self: stretch;\n  }\n}\n\n.sd-dash-feature__media > img,\n.sd-dash-feature__media > .sd-dash-gallery-photo,\n.sd-dash-feature__media > .sd-dash-cover-fallback,\n.sd-dash-feature__media .sd-dash-hero__img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  max-height: none;\n  object-fit: cover;\n  object-position: center;\n  display: block;\n}\n\n.sd-dash-feature__media .sd-dash-gallery-photo {\n  position: absolute;\n  inset: 0;\n}\n\n.sd-dash-feature__media .sd-dash-gallery-photo img,\n.sd-dash-feature__media .sd-dash-gallery-photo .sd-dash-hero__img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.sd-dash-feature__panel {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 12px;\n  padding: 22px 20px 24px;\n}\n\n@media (min-width: 900px) {\n  .sd-dash-feature__panel {\n    padding: 36px 32px;\n  }\n}\n\n.sd-dash-feature__badge {\n  display: inline-flex;\n  align-self: flex-start;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: var(--sd-bg-soft);\n  border: 1px solid var(--sd-line);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--sd-ink-soft);\n}\n\n.sd-dash-feature__title {\n  margin: 0;\n  font-family: var(--sd-font-display);\n  font-size: clamp(1.55rem, 2.6vw, 2.1rem);\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.12;\n  color: var(--sd-ink);\n}\n\n.sd-dash-feature__meta {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--sd-ink-soft);\n}\n\n.sd-dash-feature__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 4px;\n}\n\n.sd-dash-feature__stat strong {\n  display: block;\n  font-family: var(--sd-font-display);\n  font-size: 1.35rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--sd-ink);\n}\n\n.sd-dash-feature__stat span {\n  font-size: 11px;\n  color: var(--sd-ink-faint);\n}\n\n.sd-dash-feature__cta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.sd-dash-feature__empty {\n  grid-column: 1 / -1;\n  display: grid;\n  place-items: center;\n  text-align: center;\n  gap: 8px;\n  min-height: 200px;\n  padding: 36px 24px;\n}\n\n.sd-dash-feature__empty h2 {\n  margin: 0;\n  font-family: var(--sd-font-display);\n  font-size: 1.55rem;\n  font-weight: 600;\n}\n\n.sd-dash-feature__empty p {\n  margin: 0;\n  max-width: 38ch;\n  color: var(--sd-ink-soft);\n  font-size: 14px;\n}\n\n.sd-dash-cover-fallback {\n  display: grid;\n  place-items: center;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(145deg, #ddd6cb, #f0ebe3);\n  color: #7a7368;\n}\n\nhtml.dark .sd-dash-cover-fallback {\n  background: linear-gradient(145deg, #23262a, #151719);\n  color: #8d8780;\n}\n\n.sd-dash-cover-fallback__icon {\n  width: 26px;\n  height: 26px;\n  opacity: 0.7;\n}\n\n.sd-dash-hero__img,\n.sd-dash-photo__img,\n.sd-dash-album__img,\n.sd-dash-activity__thumb img,\n.sd-dash-filmstrip__item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* —— Studio pulse —— */\n.sd-dash-pulse {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0;\n  margin-bottom: 36px;\n  border: 1px solid var(--sd-line);\n  border-radius: var(--sd-r);\n  background: var(--sd-surface);\n  overflow: hidden;\n}\n\n@media (min-width: 900px) {\n  .sd-dash-pulse {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n.sd-dash-pulse__item {\n  padding: 18px 20px;\n  border-right: 1px solid var(--sd-line);\n  border-bottom: 1px solid var(--sd-line);\n}\n\n@media (min-width: 900px) {\n  .sd-dash-pulse__item {\n    border-bottom: none;\n  }\n  .sd-dash-pulse__item:nth-child(4n) {\n    border-right: none;\n  }\n}\n\n@media (max-width: 899px) {\n  .sd-dash-pulse__item:nth-child(2n) {\n    border-right: none;\n  }\n  .sd-dash-pulse__item:nth-last-child(-n + 2) {\n    border-bottom: none;\n  }\n}\n\n.sd-dash-pulse__value {\n  margin: 0;\n  font-family: var(--sd-font-display);\n  font-size: 1.85rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  color: var(--sd-ink);\n}\n\n.sd-dash-pulse__label {\n  margin: 8px 0 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--sd-ink);\n}\n\n.sd-dash-pulse__hint {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: var(--sd-ink-faint);\n}\n\n/* —— Sections —— */\n.sd-dash-section {\n  margin-bottom: 40px;\n}\n\n.sd-dash-section__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.sd-dash-section__title {\n  margin: 0;\n  font-family: var(--sd-font-display);\n  font-size: clamp(1.35rem, 1.8vw, 1.65rem);\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--sd-ink);\n}\n\n.sd-dash-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.sd-dash-chip {\n  min-height: 36px;\n  padding: 0 13px;\n  border-radius: 999px;\n  border: 1px solid var(--sd-line-strong);\n  background: var(--sd-surface);\n  color: var(--sd-ink-soft);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.sd-dash-chip.is-active {\n  background: var(--sd-ink);\n  border-color: var(--sd-ink);\n  color: var(--sd-surface);\n}\n\nhtml.dark .sd-dash-chip.is-active {\n  background: var(--sd-ink);\n  border-color: var(--sd-ink);\n  color: var(--sd-bg);\n}\n\n/* —— Recently added mosaic (compact, evenly framed) —— */\n.sd-dash-mosaic {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n@media (min-width: 720px) {\n  .sd-dash-mosaic {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 10px;\n  }\n}\n\n@media (min-width: 1100px) {\n  .sd-dash-mosaic {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    gap: 10px;\n  }\n}\n\n.sd-dash-photo {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  border-radius: var(--sd-r-xs);\n  overflow: hidden;\n  background: var(--sd-bg-soft);\n  isolation: isolate;\n  position: relative;\n}\n\n.sd-dash-photo__media {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  min-height: 0;\n  overflow: hidden;\n  background: var(--sd-bg-soft);\n}\n\n.sd-dash-photo__media img,\n.sd-dash-photo__media .sd-dash-gallery-photo,\n.sd-dash-photo__media .sd-dash-gallery-photo img,\n.sd-dash-photo__media .sd-dash-cover-fallback {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  object-fit: cover;\n  object-position: center 20%;\n  display: block;\n}\n\n.sd-dash-photo__media img,\n.sd-dash-photo__media .sd-dash-gallery-photo {\n  transition: transform var(--sd-dur) ease;\n}\n\n.sd-dash-photo:hover .sd-dash-photo__media img,\n.sd-dash-photo:hover .sd-dash-photo__media .sd-dash-gallery-photo,\n.sd-dash-photo:focus-visible .sd-dash-photo__media img,\n.sd-dash-photo:focus-visible .sd-dash-photo__media .sd-dash-gallery-photo {\n  transform: scale(1.02);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sd-dash-photo:hover .sd-dash-photo__media img,\n  .sd-dash-photo:hover .sd-dash-photo__media .sd-dash-gallery-photo,\n  .sd-dash-photo:focus-visible .sd-dash-photo__media img,\n  .sd-dash-photo:focus-visible .sd-dash-photo__media .sd-dash-gallery-photo {\n    transform: none;\n  }\n}\n\n.sd-dash-photo--a,\n.sd-dash-photo--b,\n.sd-dash-photo--c,\n.sd-dash-photo--d,\n.sd-dash-photo--e,\n.sd-dash-photo--f {\n  grid-column: auto;\n  grid-row: auto;\n}\n\n.sd-dash-photo__overlay {\n  position: absolute;\n  inset: auto 0 0 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  gap: 1px;\n  padding: 20px 8px 8px;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.72));\n  color: #fff;\n  opacity: 0;\n  transition: opacity var(--sd-dur) ease;\n}\n\n.sd-dash-photo:hover .sd-dash-photo__overlay,\n.sd-dash-photo:focus-visible .sd-dash-photo__overlay {\n  opacity: 1;\n}\n\n@media (hover: none) {\n  .sd-dash-photo__overlay { opacity: 1; }\n}\n\n.sd-dash-photo__title {\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sd-dash-photo__time {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.74);\n}\n\n.sd-dash-photo__badge {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 1;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n/* —— Split —— */\n.sd-dash-split {\n  display: grid;\n  gap: 28px;\n}\n\n@media (min-width: 1120px) {\n  .sd-dash-split {\n    grid-template-columns: minmax(0, 1.7fr) minmax(300px, 0.85fr);\n    align-items: start;\n  }\n}\n\n/* —— Album stories —— */\n.sd-dash-album-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n@media (min-width: 640px) {\n  .sd-dash-album-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.sd-dash-album {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  border-radius: var(--sd-r);\n  overflow: hidden;\n  background: transparent;\n}\n\n.sd-dash-album__cover {\n  position: relative;\n  aspect-ratio: 4 / 3;\n  overflow: hidden;\n  border-radius: var(--sd-r);\n  background: var(--sd-ink);\n}\n\n.sd-dash-album__share {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 1;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.sd-dash-album__body {\n  padding: 12px 2px 0;\n}\n\n.sd-dash-album__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 560;\n  letter-spacing: -0.02em;\n  color: var(--sd-ink);\n}\n\n.sd-dash-album__sub {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: var(--sd-ink-faint);\n}\n\n.sd-dash-album--lead {\n  grid-column: 1 / -1;\n}\n\n@media (min-width: 640px) {\n  .sd-dash-album--lead .sd-dash-album__cover {\n    aspect-ratio: 21 / 9;\n  }\n  .sd-dash-album--lead .sd-dash-album__title {\n    font-size: 1.25rem;\n  }\n}\n\n/* —— Rail —— */\n.sd-dash-rail {\n  display: grid;\n  gap: 14px;\n}\n\n.sd-dash-panel {\n  padding: 16px;\n  border-radius: var(--sd-r);\n  background: var(--sd-surface);\n  border: 1px solid var(--sd-line);\n}\n\n.sd-dash-panel .sd-dash-section__head { margin-bottom: 12px; }\n.sd-dash-panel .sd-dash-section__title { font-size: 1rem; }\n\n.sd-dash-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 12px;\n  padding: 3px;\n  border-radius: 999px;\n  background: var(--sd-bg);\n}\n\n.sd-dash-tab {\n  flex: 1;\n  min-height: 34px;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: var(--sd-ink-soft);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.sd-dash-tab.is-active {\n  background: var(--sd-surface);\n  color: var(--sd-ink);\n  box-shadow: var(--sd-shadow-soft);\n}\n\n.sd-dash-attention {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 10px;\n}\n\n.sd-dash-attention__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px;\n  border-radius: var(--sd-r-xs);\n  background: var(--sd-bg);\n}\n\n.sd-dash-attention__thumb {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  overflow: hidden;\n  flex-shrink: 0;\n  background: var(--sd-bg-soft);\n}\n\n.sd-dash-attention__body { flex: 1; min-width: 0; }\n.sd-dash-attention__title { margin: 0; font-size: 13px; font-weight: 650; }\n.sd-dash-attention__detail { margin: 2px 0 0; font-size: 12px; color: var(--sd-ink-soft); }\n\n.sd-dash-activity {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 4px;\n}\n\n.sd-dash-activity__row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  padding: 8px;\n  border-radius: var(--sd-r-xs);\n  text-decoration: none;\n  color: inherit;\n}\n\n.sd-dash-activity__row:hover { background: var(--sd-bg); }\n\n.sd-dash-activity__thumb {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  overflow: hidden;\n  flex-shrink: 0;\n  background: var(--sd-bg);\n}\n\n.sd-dash-activity__body p {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 550;\n  line-height: 1.35;\n}\n\n.sd-dash-activity__body span {\n  font-size: 11px;\n  color: var(--sd-ink-faint);\n}\n\n/* —— People —— */\n.sd-dash-clear-filters {\n  margin-top: 12px;\n}\n\n.sd-dash-people-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.sd-dash-people-head__hint {\n  margin: 0;\n  font-size: 12px;\n  color: var(--sd-ink-faint);\n}\n\n.sd-dash-people {\n  display: flex;\n  gap: 10px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  scrollbar-width: thin;\n}\n\n.sd-dash-person {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  min-width: 64px;\n  text-decoration: none;\n  color: inherit;\n}\n\n.sd-dash-person__avatar {\n  position: relative;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 2px solid var(--sd-line-strong);\n  background: var(--sd-bg-soft);\n  display: grid;\n  place-items: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--sd-ink);\n}\n\n.sd-dash-person__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.sd-dash-person__new {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 1px 5px;\n  border-radius: 999px;\n  background: var(--sd-ink);\n  color: var(--sd-surface);\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 700;\n}\n\nhtml.dark .sd-dash-person__new {\n  background: var(--sd-ink);\n  color: var(--sd-bg);\n}\n\n.sd-dash-person__name {\n  max-width: 64px;\n  font-size: 11px;\n  font-weight: 600;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sd-dash-person__count {\n  font-size: 10px;\n  color: var(--sd-ink-faint);\n}\n\n.sd-dash-people-more {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-width: 64px;\n  text-decoration: none;\n  color: var(--sd-ink);\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.sd-dash-people-more span {\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.sd-dash-people-empty {\n  display: grid;\n  gap: 8px;\n  color: var(--sd-ink-soft);\n  font-size: 13px;\n}\n\n.sd-dash-people-empty svg {\n  width: 20px;\n  height: 20px;\n  color: var(--sd-ink-faint);\n}\n\n.sd-dash-people-skel {\n  display: flex;\n  gap: 10px;\n}\n\n.sd-dash-skel--avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n}\n\n/* —— Shortcuts —— */\n.sd-dash-shortcuts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  padding: 12px;\n}\n\n.sd-dash-shortcut {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: var(--sd-bg);\n  color: var(--sd-ink);\n  text-decoration: none;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.sd-dash-shortcut svg {\n  width: 15px;\n  height: 15px;\n  color: var(--sd-ink);\n}\n\n.sd-dash-shortcut:hover { background: var(--sd-bg-soft); }\n\n/* —— Empty —— */\n.sd-dash-empty {\n  display: grid;\n  gap: 8px;\n  justify-items: start;\n  padding: 32px 20px;\n  border-radius: var(--sd-r-sm);\n  border: 1px dashed var(--sd-line-strong);\n  background: var(--sd-surface);\n}\n\n.sd-dash-empty__icon {\n  width: 28px;\n  height: 28px;\n  color: var(--sd-ink-faint);\n  margin-bottom: 4px;\n}\n\n.sd-dash-empty__title {\n  margin: 0;\n  font-family: var(--sd-font-display);\n  font-size: 1.15rem;\n  font-weight: 600;\n}\n\n.sd-dash-empty__desc {\n  margin: 0;\n  max-width: 42ch;\n  color: var(--sd-ink-soft);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n/* —— Skeletons —— */\n.sd-dash--loading {\n  width: min(100%, var(--sd-max));\n  margin: 0 auto;\n  padding: 28px var(--sd-margin) 72px;\n}\n\n.sd-dash-skel {\n  border-radius: var(--sd-r-sm);\n  background: linear-gradient(90deg, rgba(20, 18, 15, 0.05), rgba(20, 18, 15, 0.09), rgba(20, 18, 15, 0.05));\n  background-size: 200% 100%;\n  animation: sd-shimmer 1.2s ease-in-out infinite;\n}\n\nhtml.dark .sd-dash-skel {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.04));\n  background-size: 200% 100%;\n}\n\n.sd-dash-skel--header { height: 88px; margin-bottom: 24px; }\n.sd-dash-skel--hero { height: 320px; margin-bottom: 24px; border-radius: var(--sd-r); }\n.sd-dash-skel--metric { height: 88px; }\n.sd-dash-skel--photo { aspect-ratio: 1; }\n\n.sd-dash-metrics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n@media (min-width: 900px) {\n  .sd-dash-metrics { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n}\n\n.sd-dash-photo-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n@media (min-width: 720px) {\n  .sd-dash-photo-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n}\n\n/* legacy aliases kept for safety */\n.sd-dash-btn--on-dark {\n  background: var(--sd-ink);\n  color: var(--sd-surface);\n}\n.sd-dash-btn--on-dark-ghost {\n  background: var(--sd-surface);\n  border-color: var(--sd-line-strong);\n  color: var(--sd-ink);\n}\nhtml.dark .sd-dash-btn--on-dark {\n  background: var(--sd-ink);\n  color: var(--sd-bg);\n}\n\n/* Soften portal chrome so dashboard matches landing / login paper */\nmain:has(.sd-dash) {\n  padding: 0 !important;\n  background: #ffffff;\n}\n\nhtml.dark main:has(.sd-dash) {\n  background: #151412;\n}\n\n.portal-page-surface:has(.sd-dash) {\n  --pp-bg: #ffffff;\n  --pp-surface: #ffffff;\n  --pp-surface-muted: #f1f5f9;\n  --pp-text: #0f172a;\n  --pp-text-muted: #64748b;\n  --pp-text-faint: #94a3b8;\n  --pp-border: rgba(15, 23, 42, 0.1);\n  background: transparent;\n  color: #0f172a;\n}\n\nhtml.dark .portal-page-surface:has(.sd-dash) {\n  --pp-bg: #151412;\n  --pp-surface: #1c1a18;\n  --pp-surface-muted: #1c1a18;\n  --pp-text: #ffffff;\n  --pp-text-muted: #a8a399;\n  --pp-text-faint: #78746c;\n  --pp-border: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
